// dependencies
import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, BUTTON_THEME, Input } from '@st-operations/uikit/src/v2/index.js'
import sendAnalytics from '@st-operations/uikit/lib/sendAnalytics.js'

import './styles.scss'

const ENTITY = 'lookalike-audience-seeds'

const CreateUserIDSeedsModal = ({
  value,
  open,
  title = 'New User ID Seed',
  onClose = () => {},
}) => {
  const [name, setName] = useState('')

  const inputRef = useRef()

  useEffect(() => {
    if (value) {
      setName(value)
    }
  }, [value])

  useEffect(() => {
    if (open) {
      inputRef.current.focus()
    }
  }, [open])

  const onCreate = () => {
    window._api.post(`/${ENTITY}`, { name }, (error, item) => {
      if (error) {
        toast.error(error.message)
      } else {
        onClose()
        window._history.push(`/${ENTITY}/${item._id}`)
      }

      // event tracking
      sendAnalytics('create', ENTITY, item)
    })
  }

  const onDismiss = () => {
    onClose()
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      onCreate()
    }
    if (e.key === 'Escape' || (e.metaKey && e.key === 'e')) {
      e.preventDefault()
      onDismiss()
    }
  }

  const updateName = (value) => {
    setName(value)
  }

  return (
    <section className="st-new-entity-modal">
      <If condition={title}>
        <h1 className="st-new-entity-modal__title">{title}</h1>
      </If>
      <Input ref={inputRef} onChange={updateName} onKeyDown={onKeyDown} value={name} label="Name" />
      <div className="mt-4 flex justify-end">
        <Button
          className="st-new-entity-modal__button"
          theme={BUTTON_THEME.SECONDARY}
          onClick={onDismiss}
        >
          Back
        </Button>
        <Button className="st-new-entity-modal__button" onClick={onCreate}>
          Create
        </Button>
      </div>
    </section>
  )
}

CreateUserIDSeedsModal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
}

// export
export default React.memo(CreateUserIDSeedsModal)
